
import {
  HBODashWideVineRequestFilter,
  DashWideVineRequestFilter,
  // DashPlayReadyRequestFilter,
  HLSFairPlayRequestFilter,
  HLSFairPlayRequestFilterLive,
  HBODashPlayReadyRequestFilter,
  HBOHLSFairPlayRequestFilter,
  DashWideVineToolboxRequestFilter,
  HLSFairPlayToolboxRequestFilter,
} from './filters';
import { HLS_ENCODE, PLAY_READY_DRM, WIDEVINE_DRM, DASH_ENCODE, HBO, TOOLBOX_MAP } from 'containers/Player/constants';

const HBORequestFilter = (type, request, media, deviceId, streamType, drmInfo = {}, skdUri) => {
  if (streamType.includes(HLS_ENCODE)) {
    // HLS solo funciona con FairPlay.
    return HBOHLSFairPlayRequestFilter(type, request, media, skdUri);
  }
  if (streamType.includes(DASH_ENCODE) && streamType.includes(WIDEVINE_DRM)) {
    return HBODashWideVineRequestFilter(type, request, media, drmInfo);
  }
  if (streamType.includes(DASH_ENCODE) && streamType.includes(PLAY_READY_DRM)) {
    // return HBODashPlayReadyRequestFilter(type, request, media, skdUri);
    return HBODashWideVineRequestFilter(type, request, media, drmInfo);
  }
  return () => {};
};

const toolboxRequestFilter = (
  type,
  request,
  media,
  deviceId,
  streamType,
  isLive,
  contentId,
  certificate
) => {
  if (streamType.includes(HLS_ENCODE)) {
    // HLS solo funciona con FairPlay.
    return  HLSFairPlayToolboxRequestFilter(type, request, media, deviceId, contentId,certificate);
  }
    return DashWideVineToolboxRequestFilter(type, request, media, deviceId);

};

const defaultRequestFilter = (
  type,
  request,
  media,
  deviceId,
  streamType,
  isLive,
  contentId,
  certificate
) => {
  if (streamType.includes(HLS_ENCODE)) {
    // HLS solo funciona con FairPlay.
    return isLive
      ? HLSFairPlayRequestFilterLive(type, request, media, deviceId, contentId)
      : HLSFairPlayRequestFilter(type, request, media, deviceId, contentId,certificate);
  }
  if (streamType.includes(DASH_ENCODE) && streamType.includes(WIDEVINE_DRM)) {
    return DashWideVineRequestFilter(type, request, media, deviceId);
  }
  if (streamType.includes(DASH_ENCODE) && streamType.includes(PLAY_READY_DRM)) {
    // Si manifestUri.indexOf('m3u8') hay que usar la implementación de faiplayStreamer.
    // y en caso de que no se cumpla, se debe seguir el mismo filtro que para widevine.
    return DashWideVineRequestFilter(type, request, media, deviceId);
  }
  return () => {};
};

const getFilters = (config) => (type, request) => {
  const {
    provedorCode, deviceId, media, streamType, player, skdUri, isLive, contentId,
  } = config;
  const drmInfo = player.drmInfo();
  if(!isLive && TOOLBOX_MAP[provedorCode]) return toolboxRequestFilter(    type,
    request,
    media,
    deviceId,
    streamType,
    isLive,
    contentId,) 
  if (!isLive && provedorCode === HBO) {
    return HBORequestFilter(type, request, media, deviceId, streamType, drmInfo, skdUri);
  }
  return defaultRequestFilter(
    type,
    request,
    media,
    deviceId,
    streamType,
    isLive,
    contentId,
  );
};

export default getFilters;
